export const DEFAULT_SERVER_PATH = '/data/local/tmp/scrcpy-server.jar';
export function isScrcpyOptionValue(value) {
    return typeof value === 'object' &&
        value !== null &&
        typeof value.toOptionValue === 'function';
}
export function toScrcpyOptionValue(value, empty) {
    if (isScrcpyOptionValue(value)) {
        value = value.toOptionValue();
    }
    if (value === undefined) {
        return empty;
    }
    return `${value}`;
}
//# sourceMappingURL=common.js.map